(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cus-chanpinxilie"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRow = (section) => {
      if (!section || section.dataset.rowInitialized === 'true') return;
      section.dataset.rowInitialized = 'true';

      const track = section.querySelector('[data-row-track]');
      const pagination = section.querySelector('[data-row-pagination]');
      if (!track) return;

      const items = Array.from(track.children);
      let positions = [];
      let animationFrame;

      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
      const isMobileGrid = () => isMobile() && section.dataset.mobileLayout === 'grid';
      const getColumns = () => Number(isMobile() ? section.dataset.mobileColumns : section.dataset.desktopColumns) || 1;

      const setActiveDot = () => {
        if (!pagination || positions.length < 2) return;
        const current = track.scrollLeft;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;
        positions.forEach((position, index) => {
          const distance = Math.abs(current - position);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });
        pagination.querySelectorAll('button').forEach((dot, index) => {
          dot.setAttribute('aria-current', index === nearestIndex ? 'true' : 'false');
        });
      };

      const buildPagination = () => {
        if (!pagination) return;
        pagination.replaceChildren();
        positions = [];
        if (isMobileGrid() || items.length === 0) return;

        const columns = getColumns();
        const pageCount = Math.ceil(items.length / columns);
        if (pageCount <= 1) return;

        for (let page = 0; page < pageCount; page += 1) {
          const targetItem = items[Math.min(page * columns, items.length - 1)];
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          positions.push(Math.min(targetItem.offsetLeft - track.offsetLeft, maxScroll));

          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `${pagination.getAttribute('aria-label')} ${page + 1}`);
          dot.setAttribute('aria-current', page === 0 ? 'true' : 'false');
          dot.addEventListener('click', () => {
            track.scrollTo({ left: positions[page], behavior: 'smooth' });
          });
          pagination.appendChild(dot);
        }

        setActiveDot();
      };

      track.addEventListener('scroll', () => {
        cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(setActiveDot);
      }, { passive: true });

      const resizeObserver = new ResizeObserver(buildPagination);
      resizeObserver.observe(track);
      buildPagination();
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-rf-collection-row]').forEach(initializeRow);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cus-yihangzhanshichanpinxilie"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSection = (section) => {
      if (!section || section.dataset.tabsInitialized === 'true') return;
      section.dataset.tabsInitialized = 'true';

      const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
      const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));
      const viewAllLinks = Array.from(section.querySelectorAll('[data-view-all-index]'));

      const initializeCarousel = (carousel) => {
        if (!carousel || carousel.dataset.carouselInitialized === 'true') return;
        carousel.dataset.carouselInitialized = 'true';

        const track = carousel.querySelector('[data-carousel-track]');
        const previous = carousel.querySelector('[data-carousel-previous]');
        const next = carousel.querySelector('[data-carousel-next]');
        const progress = carousel.querySelector('[data-carousel-progress]');
        if (!track || !progress) return;

        let pageCount = 1;
        let currentPage = 0;
        let frame;

        const updateControls = () => {
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
          currentPage = Math.min(pageCount - 1, Math.max(0, Math.round(ratio * (pageCount - 1))));

          if (previous) {
            previous.hidden = maxScroll < 2;
            previous.disabled = track.scrollLeft <= 2;
          }
          if (next) {
            next.hidden = maxScroll < 2;
            next.disabled = track.scrollLeft >= maxScroll - 2;
          }

          progress.querySelectorAll('button').forEach((dot, index) => {
            dot.setAttribute('aria-current', index === currentPage ? 'true' : 'false');
          });
        };

        const buildProgress = () => {
          const card = track.firstElementChild;
          if (!card) return;
          const cardWidth = card.getBoundingClientRect().width;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          const visibleCards = Math.max(1, Math.floor((track.clientWidth + gap) / (cardWidth + gap)));
          pageCount = Math.max(1, Math.ceil(track.children.length / visibleCards));
          progress.replaceChildren();

          if (pageCount > 1) {
            Array.from({ length: pageCount }, (_, index) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.setAttribute('aria-label', `${progress.getAttribute('aria-label')} ${index + 1}`);
              dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
              dot.addEventListener('click', () => {
                const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
                track.scrollTo({ left: pageCount > 1 ? maxScroll * index / (pageCount - 1) : 0, behavior: 'smooth' });
              });
              progress.appendChild(dot);
            });
          }

          updateControls();
        };

        previous?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
        next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(updateControls);
        }, { passive: true });

        const resizeObserver = new ResizeObserver(buildProgress);
        resizeObserver.observe(track);
        buildProgress();
      };

      const activateTab = (index, focusTab = false) => {
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focusTab) tab.focus();
        });

        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          if (active) initializeCarousel(panel.querySelector('[data-carousel]'));
        });

        viewAllLinks.forEach((link) => {
          const active = Number(link.dataset.viewAllIndex) === index;
          link.hidden = !active;
          link.classList.toggle('is-active', active);
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(index));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activateTab(nextIndex, true);
        });
      });

      activateTab(0);
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-rf-product-tabs]').forEach(initializeSection);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-photo-puzzle"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-upload-wrap]').forEach((wrap) => {
    if (wrap.dataset.initialized === 'true') return;
    wrap.dataset.initialized = 'true';

    const input = wrap.querySelector('[data-file-input]');
    const section = wrap.closest('.custom-photo-puzzle');
    const variantSelect = section.querySelector('[data-variant-select]');
    const currentPrice = section.querySelector('[data-current-price-value]');
    const submitButton = section.querySelector('[data-submit-button]');
    const dropzone = wrap.querySelector('[data-dropzone]');
    const preview = wrap.querySelector('[data-preview]');
    const previewImage = wrap.querySelector('[data-preview-image]');
    const fileName = wrap.querySelector('[data-file-name]');
    const replaceButton = wrap.querySelector('[data-replace]');
    const error = wrap.querySelector('[data-upload-error]');
    let previewUrl = '';

    const syncVariant = () => {
      if (!variantSelect) return;
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      if (!selectedOption) return;
      if (currentPrice && selectedOption.dataset.price) {
        currentPrice.textContent = selectedOption.dataset.price;
      }
      if (submitButton) {
        submitButton.disabled = selectedOption.dataset.available !== 'true';
      }
    };

    syncVariant();
    if (variantSelect) variantSelect.addEventListener('change', syncVariant);

    const showError = (message) => {
      error.textContent = message;
      error.hidden = false;
    };

    const clearError = () => {
      error.textContent = '';
      error.hidden = true;
    };

    const showFile = (file) => {
      clearError();
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
        input.value = '';
        showError(wrap.dataset.typeError);
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        input.value = '';
        showError(wrap.dataset.sizeError);
        return;
      }
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      previewUrl = URL.createObjectURL(file);
      previewImage.src = previewUrl;
      fileName.textContent = file.name;
      preview.hidden = false;
      dropzone.hidden = true;
    };

    input.addEventListener('change', () => {
      if (input.files && input.files[0]) showFile(input.files[0]);
    });

    ['dragenter', 'dragover'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (event) => {
        event.preventDefault();
        dropzone.classList.add('is-dragging');
      });
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      dropzone.addEventListener(eventName, (event) => {
        event.preventDefault();
        dropzone.classList.remove('is-dragging');
      });
    });

    dropzone.addEventListener('drop', (event) => {
      const file = event.dataTransfer.files[0];
      if (!file) return;
      const transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
      showFile(file);
    });

    replaceButton.addEventListener('click', () => input.click());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shoppable-video-carousel')) {
    customElements.define('shoppable-video-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const opts = { signal: this.controller.signal };
        this.track = this.querySelector('.sv-track');
        this.originals = [...this.track.querySelectorAll('.sv-slide:not([data-clone])')];
        this.originals.forEach((slide, index) => { slide.dataset.index = index; });
        if (this.originals.length > 1) {
          const clone = slide => {
            const copy = slide.cloneNode(true);
            copy.dataset.clone = 'true';
            copy.removeAttribute('data-shopify-editor-block');
            copy.removeAttribute('data-block-id');
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a, button, video').forEach(element => { element.tabIndex = -1; });
            return copy;
          };
          this.track.prepend(...this.originals.map(clone));
          this.track.append(...this.originals.map(clone));
        }
        this.slides = [...this.track.querySelectorAll('.sv-slide')];
        this.active = this.originals[Math.floor(this.originals.length / 2)];
        this.markActive();
        this.visible = false;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.select(this.active, false);
        this.addEventListener('click', e => {
          const arrow = e.target.closest('[data-direction]');
          if (arrow) {
            const index = this.slides.indexOf(this.active);
            if (!this.animating) {
              this.animating = true;
              this.select(this.slides[index + Number(arrow.dataset.direction)]);
            }
            return;
          }
          const slide = e.target.closest('.sv-slide');
          if (!slide || e.target.closest('a')) return;
          if (slide !== this.active) { this.select(slide); return; }
          const video = slide.querySelector('video');
          if (!video) return;
          if (e.target.closest('.sv-mute')) {
            video.muted = !video.muted;
            const mute = slide.querySelector('.sv-mute');
            mute.textContent = video.muted ? 'Sound off' : 'Sound on';
            mute.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
            mute.setAttribute('aria-pressed', String(!video.muted));
          } else if (e.target.closest('.sv-play, .sv-video, .sv-poster')) {
            if (video.paused) this.play(slide, true); else video.pause();
          }
        }, opts);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settle(), 180);
        }, { ...opts, passive: true });
        this.track.addEventListener('keydown', e => {
          if (e.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
          e.preventDefault();
          const index = this.slides.indexOf(this.active);
          this.select(this.slides[index + (e.key === 'ArrowRight' ? 1 : -1)]);
        }, opts);
        this.slides.forEach(slide => {
          const video = slide.querySelector('video');
          if (!video) return;
          const youtubeId = this.youtubeId(video.dataset.src);
          if (youtubeId) {
            slide.dataset.youtubeId = youtubeId;
            video.hidden = true;
            slide.querySelector('.sv-mute').hidden = true;
            return;
          }
          const sync = () => {
            const playing = !video.paused && !video.ended;
            slide.querySelector('.sv-media').classList.toggle('is-playing', playing);
            const button = slide.querySelector('.sv-play');
            button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
            button.setAttribute('aria-pressed', String(playing));
            button.firstElementChild.textContent = playing ? 'Ⅱ' : '▶';
          };
          video.addEventListener('playing', () => { slide.querySelector('.sv-media').classList.add('has-played'); sync(); }, opts);
          video.addEventListener('pause', sync, opts);
          video.addEventListener('ended', sync, opts);
          video.addEventListener('error', () => { slide.querySelector('.sv-error').hidden = false; }, opts);
        });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.maybePlay(); else this.pauseAll();
        }, { threshold: .15 });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.pauseAll(); else this.maybePlay(); }, opts);
        document.addEventListener('shopify:block:select', e => {
          const slide = this.originals.find(item => item.dataset.blockId === e.detail.blockId);
          if (slide) this.select(slide);
        }, opts);
        this.resizeObserver = new ResizeObserver(() => this.select(this.active, false));
        this.resizeObserver.observe(this.track);
      }
      select(slide, smooth = true) {
        if (!slide) return;
        const left = slide.offsetLeft - (this.track.clientWidth - slide.clientWidth) / 2;
        this.track.scrollTo({ left, behavior: smooth && !this.reducedMotion ? 'smooth' : 'instant' });
      }
      update() {
        const box = this.track.getBoundingClientRect();
        const center = box.left + box.width / 2;
        const nearest = this.slides.reduce((best, slide) => {
          const rect = slide.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          return !best || distance < best.distance ? { slide, distance } : best;
        }, null)?.slide;
        if (!nearest || nearest === this.active) return;
        this.pauseAll();
        this.active = nearest;
        this.markActive();
      }
      markActive() {
        this.slides.forEach(slide => slide.classList.toggle('is-active', slide === this.active));
      }
      settle() {
        this.update();
        if (this.active?.dataset.clone) {
          this.pauseAll();
          this.active = this.originals[Number(this.active.dataset.index)];
          this.markActive();
          this.select(this.active, false);
        }
        this.animating = false;
        this.maybePlay();
      }
      maybePlay() {
        if (this.dataset.autoplay === 'true' && this.visible && !document.hidden && !this.reducedMotion) this.play(this.active);
      }
      youtubeId(value) {
        try {
          const url = new URL(value, location.href);
          const host = url.hostname.toLowerCase().replace(/^(www\.|m\.)/, '');
          let id = '';
          if (host === 'youtu.be') id = url.pathname.split('/')[1];
          if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
            id = url.searchParams.get('v') || (/^\/(shorts|embed|live)\//.test(url.pathname) ? url.pathname.split('/')[2] : '');
          }
          return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? id : '';
        } catch { return ''; }
      }
      play(slide, userInitiated = false) {
        const video = slide?.querySelector('video');
        if (!video) return;
        this.slides.forEach(item => { if (item !== slide) this.stop(item); });
        if (slide.dataset.youtubeId) {
          if (slide.querySelector('iframe')) return;
          const iframe = document.createElement('iframe');
          const params = new URLSearchParams({ autoplay: '1', playsinline: '1', rel: '0', controls: '1', mute: userInitiated ? '0' : '1', hl: 'en' });
          if (this.dataset.loop === 'true') { params.set('loop', '1'); params.set('playlist', slide.dataset.youtubeId); }
          iframe.className = 'sv-youtube';
          iframe.title = video.getAttribute('aria-label') || 'YouTube video';
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          iframe.src = 'https://www.youtube.com/embed/' + slide.dataset.youtubeId + '?' + params.toString();
          slide.querySelector('.sv-media').append(iframe);
          slide.querySelector('.sv-play').hidden = true;
          return;
        }
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.play().catch(() => {});
      }
      stop(slide) {
        slide.querySelector('video')?.pause();
        const iframe = slide.querySelector('iframe');
        if (iframe) {
          iframe.remove();
          slide.querySelector('.sv-play').hidden = false;
        }
      }
      pauseAll() { this.slides.forEach(slide => this.stop(slide)); }
      disconnectedCallback() {
        this.pauseAll(); this.controller.abort(); this.observer.disconnect(); this.resizeObserver.disconnect(); cancelAnimationFrame(this.frame); clearTimeout(this.settleTimer);
        this.track.querySelectorAll('[data-clone]').forEach(slide => slide.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
